import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/AE';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得減少保單價值準備金條款說明
export function getAgreeTermsAE() {
    return get(`${url}/getAgreeTerms`);
};

// 減少保單價值準備金條款同意
export function postAgreeAE() {
    return post(`${url}/agree`);
};

// 保戶進入減少保單價值準備金前，取得先前減少保單價值準備金記錄
export function getInfoAE() {
    return get(`${url}/info`);
}

/**
 * sumbit
 * @param {Object} data {funddeFlg:"string",fundBankList:"Array"}
 */
export function submitAE(data) {
    return post(`${url}/submit`, { valReserve: data }, { ...options, repeatRequestCancel: true });
}
